import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useGlobalContext } from "../../../Config";
import SubProductosTable from "./SubProductosTable";
import ServiciosTable from "./ServiciosTable";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import StepByStep from "../../../shared/components/StepByStep";
import Loader from "../../../shared/ui/Loader";
import {
  validarDisponibilidad,
  guardarDetallesCotizacion,
  getServiciosByIdEmpresa,
  getAllSubproductosByIdProducto,
} from "../../../services/CotizacionService.js";
import { getClienteById } from "../../../services/ClienteService.js";
import useIsMobile from "../../../shared/hooks/useIsMobile.js";
const items = [
  {
    label: "Seleccione Cliente",
  },
  {
    label: "Seleccione Productos",
  },
  {
    label: "Añada Servicios",
  },
  {
    label: "Defina Tarifas",
  },
];
const CotizacionSelectSubProductosYServicios = (props) => {
  // REDIRECCION
  const location = useLocation();
  const navigate = useNavigate();
  const [isFormAgregarProducto] = useState(
    location.state?.isFormAgregarProducto || false
  );
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const selected = searchParams.get("selected");
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const activeIndex = parseInt(searchParams.get("activeIndex"));
  const [carro, setCarro] = useState([]);
  const selectedItemsParam = searchParams.get("selectedItems");
  const adicional = searchParams.get("adicional");

  const [cliente, setCliente] = useState(null);
  const { baseUrl } = useGlobalContext();

  const [desde] = useState(searchParams.get("desde"));
  const [hasta] = useState(searchParams.get("hasta"));
  const [loading, setLoading] = useState(false);
  const [showSeleccion] = useState(true);
  const [isConfirmingSelection, setIsConfirmingSelection] = useState(false);

  //-------- INICIO CONFIRMACION DE PRODUCTOS ------
  const handleConfirmarItem = async () => {
    let keepLoadingUntilRedirect = false;
    setIsConfirmingSelection(true);
    setLoading(true);
    try{
      function formatDate(dateString) {
        const parts = dateString.split("/");
        if (parts.length === 3) {
          const [day, month, year] = parts;
          const formattedDay = day.padStart(2, "0");
          const formattedMonth = month.padStart(2, "0");
          return `${year}-${formattedMonth}-${formattedDay}`;
        }
        return dateString;
      }

      if (currentIndex < carro.length - 1) {
        // Guarda la selección de servicios del producto actual y continúa con el siguiente
        setCarro((prevCarro) => {
          const updatedCarro = [...prevCarro];
          updatedCarro[currentIndex] = {
            ...updatedCarro[currentIndex],
            servicios: selectedServicios,
          };
          return updatedCarro;
        });
        setCurrentIndex((prevIndex) => prevIndex + 1);
        return;
      }

      // Último producto: consolidar el carro y delegar el guardado al backend
      const carroActualizado = [
        ...carro.slice(0, currentIndex),
        { ...carro[currentIndex], servicios: selectedServicios },
      ];

      const items = carroActualizado.map((item) => ({
        idProducto: item.id,
        idEmpresa: item.id_empresa,
        descripcion: item.nombre_producto,
        codigoProducto: item.codigo_producto,
        desde: formatDate(desde),
        hasta: formatDate(hasta),
        tramo: null,
        documentoCobro: "Factura Afecta",
        tipo: "Incluido",
        contrato: true,
        consolidado: false,
        agrupamiento: 0,
        unidadMedida: item.unidad,
        cantidad: item.metraje_producto ?? 0,
        moneda: item.moneda,
        tarifaBase: item.tarifa_base,
        tarifaCliente: item.tarifa_base,
        tarifaDiaria: 0,
        tarifaMensual: 0,
        descuento: 0,
        servicios: (item.servicios || []).map((serv) => ({
          idElemento: serv.id,
          descripcion: serv.descripcion,
          tarifaBase: serv.tarifa_base,
          moneda: serv.moneda,
          unidad: serv.unidad,
        })),
        serviciosUnicos: (item.servicios_unicos || []).map((serv) => ({
          idElemento: serv.id,
          descripcion: serv.descripcion,
          tarifaBase: serv.tarifa_base,
          moneda: serv.moneda,
          unidad: serv.unidad,
        })),
      }));

      // Validar disponibilidad antes de escribir
      const data = await validarDisponibilidad(
        baseUrl,
        items.map((item) => ({
          idProducto: item.idProducto,
          fechaInicio: item.desde,
          fechaTermino: item.hasta,
        }))
      );

      if (data.respuesta === false) {
        alert(
          "Uno o más productos ya fueron arrendados. Por favor vuelva a generar la cotización"
        );
        return;
      }

      // El backend, en una sola transacción: desactiva los detalles reemplazados,
      // inserta productos/servicios normalizando el Gasto Comun (uno por producto,
      // sin duplicados), auto-inserta los subproductos incluidos desde BD y
      // actualiza la cabecera de la cotización.
      await guardarDetallesCotizacion(baseUrl, {
        idCotizacion,
        idCliente: cliente.id,
        desde: formatDate(desde),
        hasta: formatDate(hasta),
        adicional: !!adicional,
        actualizarCotizacion: true,
        items,
      });

      const desdeTransformed = formatDate(desde);
      const hastaTransformed = formatDate(hasta);

      const newURL = `/revisarCotizacion?activeIndex=3&idCliente=${cliente.id}&idCotizacion=${idCotizacion}&desde=${desdeTransformed}&hasta=${hastaTransformed}`;
      keepLoadingUntilRedirect = true;
      navigate(newURL);

    }catch(error){
      console.error("Error al añadir productos y servicios:", error);
      alert(error.message || "Error al añadir productos y servicios");
    }finally{
    if (!keepLoadingUntilRedirect) {
      setLoading(false);
      setIsConfirmingSelection(false);
    }
    }
  };

  //-------- FIN CONFIRMACION DE PRODUCTOS ------

  const fetchDataCliente = async () => {
    try {
      setLoading(true);
      const data = await getClienteById(baseUrl, idCliente);
      setCliente(data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (idCliente && selected === "true" && activeIndex) {
      fetchDataCliente();
    }
  }, [idCliente, selected]);

  const [subproductos, setSubproductos] = useState([]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [servicios, setServicios] = useState([]);
  const handleServicioSelectionChange = (e) => {
    setSelectedServicios(e.value);
  };
  const [selectedServicios, setSelectedServicios] = useState([]);

  useEffect(() => {
    if (selectedItemsParam) {
      const selectedItems = JSON.parse(decodeURIComponent(selectedItemsParam));

      setCarro(selectedItems);
    }
  }, [selectedItemsParam]);
  useEffect(() => {
    if (carro.length > 0 && !isConfirmingSelection) {
      const fetchDataAndUpdateState = async () => {
        const currentCarroItem = carro[currentIndex];
        if (!currentCarroItem) {
          alert("no hay items en el carro");
          return;
        }

        try {
          setLoading(true);
          const urlServicios = getServiciosByIdEmpresa(
            baseUrl,
            currentCarroItem.id_empresa
          );
          const urlSubproductos = getAllSubproductosByIdProducto(
            baseUrl,
            currentCarroItem.id
          );

          const [dataServicios, dataSubproductos] = await Promise.all([
            urlServicios,
            urlSubproductos,
          ]);

          if (Array.isArray(dataServicios.servicios)) {
            setServicios(dataServicios.servicios);
          }

          if (Array.isArray(dataSubproductos.subproductos)) {
            setSubproductos(dataSubproductos.subproductos);
          }
          setLoading(false);
        } catch (error) {
          console.error(error);
          setLoading(false);
        }
      };
      fetchDataAndUpdateState();
    }
  }, [carro, currentIndex, isConfirmingSelection]);

  // Auto-selección de servicios según los flags del producto actual
  useEffect(() => {
    if (carro.length === 0 || isConfirmingSelection) {
      return;
    }

    const currentCarroItem = carro[currentIndex];
    if (!currentCarroItem) {
      return;
    }

    const selectedServiciosArray = [];

    const gastoComunItem = servicios.find(
      (servicio) => servicio.descripcion === "Gasto Comun"
    );
    if (gastoComunItem) {
      selectedServiciosArray.push({
        ...gastoComunItem,
        incluido: true,
        tarifa_base: 0,
        tarifa_cliente: 0,
      });
    }

    if (currentCarroItem.electricidad) {
      const electricidadItem = servicios.find(
        (servicio) => servicio.descripcion === "Electricidad"
      );
      if (electricidadItem) {
        selectedServiciosArray.push({ ...electricidadItem, incluido: true });
      }
    }

    if (currentCarroItem.agua) {
      const aguaItem = servicios.find(
        (servicio) => servicio.descripcion === "Agua"
      );
      if (aguaItem) {
        selectedServiciosArray.push({ ...aguaItem, incluido: true });
      }
    }

    if (currentCarroItem.internet) {
      const internetItem = servicios.find(
        (servicio) => servicio.descripcion === "Internet"
      );
      if (internetItem) {
        selectedServiciosArray.push({ ...internetItem, incluido: true });
      }
    }

    window.scrollTo({ top: 0, behavior: "smooth" });

    setSelectedServicios(selectedServiciosArray);
  }, [carro, currentIndex, servicios, isConfirmingSelection]);

  const isMobile = useIsMobile();

  return (
    <div className="card">
      {!isMobile && activeIndex && <StepByStep activeIndex={activeIndex} items={items} />}
      {currentIndex < carro.length && showSeleccion && (
        <>
          {loading ? (
            <>
              <Loader></Loader>
            </>
          ) : (
            <>

              <div className="p-fluid formgrid grid">
                <div
                  className="field col-12 md:col-12"
                  style={{ display: "flex", justifyContent: "start" }}
                >
                  <Button
                    label="Volver a Productos"
                    icon="pi pi-arrow-left"
                    outlined
                    rounded
                    onClick={() => {
                      if(isFormAgregarProducto){
                        navigate(
                          `/agregarProducto?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desde}&hasta=${hasta}`
                        );
                      }else{
                        navigate(
                          `/selectProductos?idCotizacion=${idCotizacion}&idCliente=${idCliente}&selected=true&activeIndex=1`
                        );
                      }

                    }}
                    style={{ width: "200px" }}
                  ></Button>
                </div>
                <div
                  className=" col-12 md:col-12"
                  style={{ marginBottom: "15px" }}
                >
                  <h6>Cotizacion # {idCotizacion}</h6>
                </div>
                <div
                  className=" col-12 md:col-12"
                  style={{ marginBottom: "15px" }}
                >
                  <h6>
                    Seleccione servicios para el producto
                  </h6>
                </div>
                <div className=" col-12 md:col-6" id="subproductosDataTable">
                  <SubProductosTable
                    subproductos={subproductos}
                    carro={carro}
                    currentIndex={currentIndex}
                  />
                </div>

                <div className=" col-12 md:col-6">
                  <ServiciosTable
                    carro={carro}
                    currentIndex={currentIndex}
                    servicios={servicios}
                    selectedServicios={selectedServicios}
                    handleServicioSelectionChange={
                      handleServicioSelectionChange
                    }
                  />
                </div>
                <div className="field col-12 md:col-12"></div>
              </div>
            </>
          )}
        </>
      )}

      <div
        className="field col-12 md:col-12"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Button
          visible={showSeleccion}
          label="Confirmar Selección"
          icon="pi pi-check"
          className="p-button mr-2 mb-2 p-button-rounded"
          onClick={handleConfirmarItem}
          style={{ width: "400px"}}
          disabled={loading}
          raised
        />
      </div>
    </div>
  );
};

export default CotizacionSelectSubProductosYServicios;
